import React, { useState } from 'react';
import styled from 'styled-components';
import AuthorizedLinks from './AuthorizedLinks';
import MenuAppInfo from './MenuAppInfo';
import MenuTitle from './MenuTitle';
import MenuUserName from './MenuUserName';
import ToggleMenuButton from './ToggleMenuButton';

const Menu = styled.div`
  display: flex;
  flex-direction: column;
  width: ${(props) => (props.isCollapsed ? '20px' : '224px')};
  background: #fff;
  line-height: 2.5;
  overflow-y: auto;
  overflow-x: ${(props) => (props.isCollapsed ? 'hidden' : 'auto')};
  transition: width 300ms cubic-bezier(0.2, 0, 0, 1);

  * {
    visibility: ${(props) => (props.isCollapsed ? 'hidden' : 'visible')};
    opacity: ${(props) => (props.isCollapsed ? '0' : '1')};
    transition: visibility 0s, opacity 0.5s linear;
  }
`;

function SelectedModuleMenu() {
  const [isCollapsed, setIsCollapsed] = useState(false);
  return (
    <>
      <Menu isCollapsed={isCollapsed}>
        <MenuTitle />
        <MenuUserName />
        <AuthorizedLinks />
        <MenuAppInfo />
      </Menu>
      <ToggleMenuButton
        isCollapsed={isCollapsed}
        onToggleMenuClick={() => setIsCollapsed(!isCollapsed)}
      />
    </>
  );
}

export default SelectedModuleMenu;
